import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveImage } from '../ResponsiveImage';
import { Details } from './Details';
import {
  StyledRecipeInformationSection,
  Header,
  Subheadline,
  Headline,
  Container,
  ImagePanel,
  ImageOuter,
  ImageWrapper,
  DetailsWrapper,
} from './styles.js';

export const RecipeInformationSection = ({
  title,
  image,
  icon = null,
  notice = '',
  description = '',
  details = [],
  headline = '',
  subheadline = '',
  backgroundColor = 'background.base',
  buttonVariant = 'bone',
  link = null,
}) => (
  <StyledRecipeInformationSection backgroundColor={backgroundColor}>
    {headline || subheadline ? (
      <Header>
        <Subheadline>{subheadline}</Subheadline>
        <Headline>{headline}</Headline>
      </Header>
    ) : null}
    <Container>
      <ImagePanel>
        <ImageOuter>
          <ImageWrapper>
            {image && (
              <ResponsiveImage
                src={image.src}
                alt={image.alt}
                layout="fill"
                objectFit="cover"
              />
            )}
          </ImageWrapper>
        </ImageOuter>
      </ImagePanel>
      <DetailsWrapper>
        <Details
          title={title}
          icon={icon}
          notice={notice}
          description={description}
          details={details}
          buttonVariant={buttonVariant}
          link={link}
        />
      </DetailsWrapper>
    </Container>
  </StyledRecipeInformationSection>
);

RecipeInformationSection.displayName = 'RecipeInformationSection';

RecipeInformationSection.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired,
  icon: PropTypes.object,
  notice: PropTypes.string,
  description: PropTypes.node.isRequired,
  details: PropTypes.array,
  headline: PropTypes.string,
  subheadline: PropTypes.string,
  backgroundColor: PropTypes.string.isRequired,
  buttonVariant: PropTypes.string.isRequired,
  link: PropTypes.object,
};
